<template>
  <Modal
    ref="exportAsExcelModalRef"
    @onPositiveActionClick="exportAsExcelConfirm()"
    positiveActionText="Toplu Ürün Yönetimine Git"
    class="exportAsExcelModal"
    type="info"
    withCloser="true"
  >
    <template v-slot:body>
      <div class="exportAsExcelModal-context">
        <h2 class="exportAsExcelModal-title">
          Excel dosyasını Toplu Ürün Yönetimi’nde bulabilirsiniz
        </h2>
        <p v-html="excelExportContent"></p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref } from "vue";
import { Modal } from "@n11/so-ui-components";
import { NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE } from "@/utils/enum/configs";
import { useStore } from "vuex";

const store = useStore();

const isBulkConfigEnable = computed(
  () =>
    store.getters["common/getConfigList"][
      NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE
    ]
);

const props = defineProps({
  excelExportContent: {
    type: String,
    required: false,
    default: "",
  },
});

const exportAsExcelModalRef = ref();

const exportAsExcelConfirm = () => {
  const excelReport = "true";
  if (isBulkConfigEnable.value === "true") {
    window.location = `/selleroffice/v2/product/create/bulk?excelReport=${excelReport}`;
  } else {
    window.location = "/selleroffice/integration/main#fileTabView";
  }
};

const openExportasExcelModal = () => exportAsExcelModalRef?.value?.openModal();

defineExpose({
  openExportasExcelModal,
});
</script>

<style lang="scss" scoped>
.exportAsExcelModal {
  &-title {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    line-height: 26px;
    margin-bottom: 0;
  }

  &-context {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 32px;
    padding-bottom: 16px;

    p {
      line-height: 24px;
      letter-spacing: -0.2px;

      b {
        font-weight: bold;
      }
    }
  }
}
</style>
